import get from 'lodash/get';

import i18n from 'shared/lib/i18n';

import { formatRole, loadServiceData } from '../../utils';

import {
  CHANGE_LOGIN_TYPE,
  COMPLETE_USER_SIGN_UP,
  RESET_PASSWORD,
  UPDATE_EMAIL_PHONE,
} from './constants';

export const findBuildingRoles = (roles, building) => {
  if (!roles || !roles.length) return [];
  let filteredRoles = [];
  filteredRoles = roles.filter((role) => {
    if (role.active === false) return false;
    if (Number(role.propertyId) === Number(building.id)) {
      return true;
    }
    if (Number(role.propertyId) === Number(get(building, 'parent.id', -1))) {
      return true;
    }
    const unitIds = get(building, 'units', []) || [];
    if (unitIds && unitIds.indexOf(Number(role.propertyId)) > -1) {
      return true;
    }
    return false;
  });
  return filteredRoles;
};

export const findPMCRoles = (roles, PMC) => {
  if (!roles || !roles.length) return [];
  let filteredRoles = [];
  filteredRoles = roles.filter((role) => {
    if (role.active === false) return false;
    if (Number(role.propertyId) === Number(PMC.id)) {
      return true;
    }
    const buildingIds = get(PMC, 'buildings', []) || [];
    if (buildingIds && buildingIds.indexOf(Number(role.propertyId)) > -1) {
      return true;
    }
    return false;
  });
  return filteredRoles;
};

export const findPersonPhoneNumber = (person) =>
  get(
    get(person, 'contactInfo', []).find((item) => item.type === 'phone_number'),
    'contactInfo',
  );

export const findPersonEmail = (person) =>
  get(
    get(person, 'contactInfo', []).find((item) => item.type === 'email'),
    'contactInfo',
  );

export const getAllPersonRoles = (person) => [
  ...get(person, 'residentRoles', []),
  ...get(person, 'staffRoles', []),
  ...get(person, 'boardMemberRoles', []),
];

export const getAllResidentRoles = (person) => [
  ...get(person, 'residentRoles', []),
  ...get(person, 'boardMemberRoles', []),
];

export const getFullName = (person) =>
  [person?.firstName, person?.lastName].filter(Boolean).join(' ');

export const getPartName = (person) => {
  const lastNameLetter = person?.lastName?.length ? person.lastName[0] : '';
  return !person || !Object.keys(person).length
    ? ''
    : `${person.firstName} ${lastNameLetter}`;
};

export const getRoleName = (
  roleId,
  allRoleOptions = loadServiceData().role,
) => {
  if (!roleId || !allRoleOptions || !allRoleOptions.length) return '';
  const role = allRoleOptions.find(
    (option) => Number(option.id) === Number(roleId),
  );
  return get(role, 'name', '');
};

export const getRoleIdByName = (roleName) => {
  const roles = loadServiceData().role;
  if (!roles?.length || !roleName) return null;
  return roles.find(({ name }) => name === roleName)?.id;
};

export const checkLeftRole = (personRoles, movedRole) => {
  let isBoardMember;
  if (personRoles.length === 2 && movedRole === i18n.t('roles.owner')) {
    isBoardMember = personRoles.find(
      (option) => getRoleName(option.role) === 'board_member',
    );
  }
  return isBoardMember;
};

export const checkHasRole = (roleName, roleId) =>
  getRoleName(roleId) === roleName;

const validateCredentials = (values, isUserName, isPassword) => {
  const { email, phoneNumber, password, confirmPassword } = values;
  const errors = {};
  if (isUserName) {
    if (!email && !phoneNumber) {
      errors.email = i18n.t('errors.emailOrPhoneRequired');
      errors.phoneNumber = i18n.t('errors.emailOrPhoneRequired');
    }
  }
  if (isPassword) {
    if (!password) {
      errors.password = i18n.t('errors.required');
    }
    if (password !== confirmPassword) {
      errors.password = i18n.t('errors.passwordMatch');
      errors.confirmPassword = i18n.t('errors.passwordMatch');
    }
  }
  return errors;
};

export const onManageUserValidate = (values) => {
  const { action } = values;
  let errors = {};
  switch (action) {
    case UPDATE_EMAIL_PHONE:
      errors = validateCredentials(values, true);
      break;
    case RESET_PASSWORD:
      errors = validateCredentials(values, false, true);
      break;
    case CHANGE_LOGIN_TYPE:
    case COMPLETE_USER_SIGN_UP:
      errors = validateCredentials(values, true, true);
      break;
    default:
      break;
  }
  return errors;
};

export const getMoveOutConfirmMessage = (
  personName,
  roleName,
  propertyName,
  isLastRole,
) => {
  const lastRoleWarning = i18n.t('person.warningPersonRemove');
  const message = i18n.t('person.removeRoleName', {
    personName,
    roleName,
    propertyName,
  });
  if (isLastRole) return `${message}\n${lastRoleWarning}`;
  return message;
};

export const getPersonListUrl = (props, personType = 'staff') => {
  const currentUrl = props?.location?.pathname;
  if (!currentUrl) return null;
  if (currentUrl.includes(personType)) {
    return currentUrl.substring(
      0,
      currentUrl.indexOf(personType) + personType.length,
    );
  }
  return currentUrl;
};

export const contactPersonRole = (contactPerson = {}) => {
  const { role, isAdmin, isService } = contactPerson || {};
  if (isAdmin) return i18n.t('roles.admin');
  if (isService) return i18n.t('roles.carsonService');
  return formatRole(getRoleName(role)) || i18n.t('common.NR');
};
